import { Button } from 'components'
import React from 'react'

// import { useCollegeUser, useLoginState } from 'state'
import { DownloadIcon } from '@radix-ui/react-icons'

import PaymentsImage from '../assets/payment.svg'

// import { BrochureLink } from '../data/college.data'
import ApplyNowButton from './ApplyNowButton'

const FeesSection = () => {
  // const { collegeUser } = useCollegeUser()
  // const { user, isLoggedIn } = useLoginState()

  return (
    <section className="bg-gray-200 text-black">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:max-w-screen-2xl lg:px-8 w-full">
        <div className="flex justify-between gap-x-20">
          <div className="flex flex-col gap-y-6 lg:w-8/12 w-full">
            <h3 className="text-4xl font-semibold tracking-tight">
              Fee Structure
            </h3>
            <p className="text-base md:text-lg lg:text-xl">
              <span>Tution Fees</span>{' '}
              <span
                className="font-semibold"
                style={{
                  textDecoration: 'underline',
                  textDecorationColor: '#FCBB74',
                  textDecorationThickness: '10px',
                  textDecorationSkipInk: 'none',
                  textUnderlineOffset: '-50%',
                  textUnderlinePosition: 'under'
                }}>
                INR 1,50,000/year
              </span>
            </p>
            <p className="text-base md:text-lg">
              There are no overhead charges besides the Tuition fees, and we
              plan to give scholarship to majority of our students based on the
              scholarship test
            </p>

            <div className="text-base md:text-lg lg:text-xl">
              <p>Total Overall Fees:</p>
              <p
                className="font-semibold text-lg"
                style={{
                  textDecoration: 'underline',
                  textDecorationColor: '#FCBB74',
                  textDecorationThickness: '10px',
                  textDecorationSkipInk: 'none',
                  textUnderlineOffset: '-50%',
                  textUnderlinePosition: 'under'
                }}>
                INR 4,50,000{' '}
              </p>
            </div>

            <p className="text-base md:text-lg font-semibold">
              60% of students will get assured scholarships upto 20%
            </p>

            <div className="flex flex-wrap items-center gap-6">
              <ApplyNowButton />
              <Button
                disabled
                className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
                <DownloadIcon className="w-4 h-4" />
                Download Brochure
              </Button>
              {/* {!(collegeUser && collegeUser.phone_verified) ? (
                <Link
                  href={
                    user && isLoggedIn ? '/school/dashboard' : '/school/login'
                  }>
                  <Button className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
                    <DownloadIcon className="w-4 h-4" />
                    Download Brochure
                  </Button>
                </Link>
              ) : (
                <a href={BrochureLink} target={'_blank'} rel="noreferrer">
                  <Button className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
                    <DownloadIcon className="w-4 h-4" />
                    Download Brochure
                  </Button>
                </a>
              )} */}
            </div>
          </div>

          <div className="hidden lg:block w-4/12">
            <img className="w-full" src={PaymentsImage.src} alt="" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeesSection
